import { ButtonIcon } from "../../../../../../common/APICommon";
import { Input, NumberInput } from "../../../../../../common/Input";

import AddIcon from '@mui/icons-material/Add';

export function ObjectiveForm({
  categoryId,
  formData = {},
  remainingPercentage,
  errors,
  onFieldChange,
  onAdd,
  disabled = false
}) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div>
        <Input
          type="text"
          value={formData.code || ""}
          onChange={(e) => onFieldChange(categoryId, "code", e.target.value)}
          placeholder="Objective Code"
          error={errors.code}
          errorMessage="Code is required"
        />
      </div>
      <div className="md:col-span-2">
        <Input
          type="text"
          value={formData.description || ""}
          onChange={(e) => onFieldChange(categoryId, "description", e.target.value)}
          placeholder="Objective Description"
          error={errors.description}
          errorMessage="Description is required"
        />
      </div>
      <div className="flex space-x-2">
        <div className="flex-1">
          <NumberInput
            value={formData.percentage || ""}
            onChange={(e) => onFieldChange(categoryId, "percentage", e.target.value)}
            placeholder="Percentage"
            min="0"
            max={remainingPercentage}
            step="0.01"
            error={errors.percentage}
            errorMessage="Valid percentage required"
          />
        </div>
        <ButtonIcon
          icon={<AddIcon />}
          className={`border-none cursor-pointer ${
            disabled
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'bg-blue-500 hover:bg-blue-600 text-white'
          }`}
          onClick={onAdd}
          disabled={disabled}
        />
      </div>
    </div>
  );
}